<img
    [src]="src"
    [srcset]="srcSet"
    [attr.alt]="image.name ? image.name : null"
    [height]="height"
    [width]="width"
    [index]="index"
    [indexLoadingThreshold]="indexLoadingThreshold"
    [ngStyle]="style ? style : null"
    [ngClass]="['kk-intersection', index !== undefined && index < 1 ? 'kk-intersection_instant' : '']"
    appIntersectionLazyImage
    [intersectionOptions]="intersectionOptions"
    [attr.fetchPriority]="index !== undefined && index < 1 ? 'high' : 'auto'"
    *ngIf="image && image.src"
/>
